const modules = import.meta.glob('./*/*.ts', { eager: true });

const messages: Record<string, { translation: Record<string, string> }> = {};

Object.keys(modules).forEach((path) => {
  const match = path.match(/\.\/([^/]+)\/([^/]+)\.ts$/);
  if (match) {
    const [, lang] = match;
    const module = modules[path] as { common?: Record<string, string>; default?: Record<string, string> };

    if (!messages[lang]) {
      messages[lang] = { translation: {} };
    }

    // Merge translation content - check for both 'common' and 'default' exports
    const content = module.common || module.default;
    if (content) {
      messages[lang].translation = {
        ...messages[lang].translation,
        ...content
      };
    }
  }
});

export default messages;
